import { FETCH_FAQ, FETCH_LANDING_CONTENT, SET_ACTIVE_FAQ } from './constants'

export const fetchFAQ = {
  request: currentPhoneId => ({ type: FETCH_FAQ['REQUEST'], currentPhoneId }),
  success: (questions, currentPhoneId) => ({
    type: FETCH_FAQ['SUCCESS'],
    questions,
    currentPhoneId
  })
}

export const setActiveFAQ = activeFAQ => ({
  type: SET_ACTIVE_FAQ,
  activeFAQ
})

export const fetchLandingContent = {
  request: currentPhoneId => ({
    type: FETCH_LANDING_CONTENT['REQUEST'],
    currentPhoneId,
    landing: true
  }),
  success: (landingCategories, currentPhoneId) => ({
    type: FETCH_LANDING_CONTENT['SUCCESS'],
    landingCategories,
    currentPhoneId
  })
}



// WEBPACK FOOTER //
// ./src/containers/FAQs/actions.js